export default "__VITE_ASSET__C$_qKy9c__"